import React, { Component } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { withTranslation } from 'react-i18next';

class ImageCropContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        const { crop, croppedImageUrl, src, circularCrop } = this.props;
        // console.log("src----->",this.props.src)
        return (
            <div className="modalinnerbodyContainer">
                {src && (
                    <ReactCrop
                        src={src}
                        crop={crop}
                        circularCrop={circularCrop}
                        onImageLoaded={this.props.onImageLoaded}
                        onComplete={this.props.onCropComplete}
                        onChange={this.props.onCropChange}
                    />
                )}
            </div>
        );
    }
}


ImageCropContent.defaultProps = {
    circularCrop: true
}

export default withTranslation()(ImageCropContent);
